export default "__VITE_ASSET__CMdxPLLD__"